/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%] > div[_ngcontent-%COMP%]{display:flex}[_nghost-%COMP%] > div[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;flex:auto;margin:0 2px}label[_ngcontent-%COMP%]{font-size:8pt}.floating[_nghost-%COMP%]   span[_ngcontent-%COMP%]{opacity:1}"];
export { styles as styles };
